import { render, staticRenderFns } from "./etablissement.vue?vue&type=template&id=4d172e6d&scoped=true"
import script from "./etablissement.vue?vue&type=script&setup=true&lang=js"
export * from "./etablissement.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d172e6d",
  null
  
)

export default component.exports